/** ECharts colors that follow HMIS light/dark theme. PDF download stays light. */
export type ChartThemeColors = {
  isDark: boolean;
  text: string;
  muted: string;
  axis: string;
  splitLine: string;
  tooltipBg: string;
  tooltipBorder: string;
  tooltipText: string;
  currentLine: string;
};

export const getChartTheme = (
  mode: "light" | "dark",
  isDownload = false,
): ChartThemeColors => {
  const isDark = !isDownload && mode === "dark";
  return {
    isDark,
    text: isDark ? "#f5f5f5" : "#333333",
    muted: isDark ? "#a8a8a8" : "#666666",
    axis: isDark ? "#a8a8a8" : "#666666",
    splitLine: isDark ? "#3a3a3e" : "#e0e0e0",
    tooltipBg: isDark ? "#252528" : "#ffffff",
    tooltipBorder: isDark ? "#3a3a3e" : "#cccccc",
    tooltipText: isDark ? "#f5f5f5" : "#000000",
    currentLine: isDark ? "#f5f5f5" : "#000000",
  };
};

export const chartAxisStyle = (t: ChartThemeColors) => ({
  nameTextStyle: { color: t.axis, fontSize: 12 },
  axisLabel: { color: t.axis },
  axisLine: { lineStyle: { color: t.splitLine } },
  axisTick: { lineStyle: { color: t.splitLine } },
  splitLine: { lineStyle: { color: t.splitLine } },
});
